<script>
  let { date, opening = null, role = "viewer", onSelect } = $props();

  let canEdit = $derived(role === "admin" || role === "manager");
  let buttonClass = $derived(canEdit ? "presence-cell cursor-pointer hover:bg-blue-50/80" : "presence-cell cursor-default");

  function handleSelect() {
    if (!canEdit) return;
    onSelect?.(date);
  }
</script>

<button class={buttonClass} onclick={handleSelect}>
  {#if opening}
    <div class="flex gap-1 items-center">
      <span class={`bg-${opening.user.color} text-white text-xxs rounded-sm px-1 py-0.5`} title={opening.user.name}>
        {opening.user.name}
      </span>
      {#if opening.notes?.length > 0}
        <span class="text-gray-400" title={opening.notes}>*</span>
      {/if}
    </div>
  {/if}
</button>
